import Iklan1 from "../../media/home/banner-iklan (1).webp";
import Iklan2 from "../../media/home/banner-iklan (2).webp";
import Iklan3 from "../../media/home/banner-iklan (3).webp";

const iklanimages = [Iklan3, Iklan1, Iklan2];

export default iklanimages;
